import React from "react";
import "../../App.css";
import GoodsIntimation from "../GoodsIntimation";

function Gri({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("gri")) {
    return;
  }
  return (
    <div className="page-challan">
      <GoodsIntimation sessionObject={sessionObject} />
    </div>
  );
}

export default Gri;
